<template>
  <v-container>
    <v-layout wrap justify-center>
      <v-card class="ma-0 mt-0">
        <v-form id="package">
          <div class="ma-2">연동장비 정보 <span v-if="device_id">{{ device_id }}</span></div>
            
          <v-autocomplete dense outlined class="ma-1" style="height: 45px; width: auto;" v-show="false"
            id="company" 
            ref="company" 
            label="경영체✽" 
            v-model="company"
            :items="companyItems"
            :menu-props="{ top: false, offsetY: true }"
            :loading="loadingMac" 
            no-data-text="자료(권한)이 없습니다."
            item-text="company_name"
            return-object
            @change="changeCompany()"
            @focus="comboCompanies()"
            clearable
          />

          <v-autocomplete dense outlined  class="ma-1" style="height: 45px; width: auto;" 
            id="farm" 
            ref="farm" 
            label="농장/사업장✽" 
            v-model="farm"
            :items="farmItems"
            :menu-props="{ top: false, offsetY: true }"
            no-data-text="자료(권한)이 없습니다."
            item-text="farm_name"
            return-object
            @change="changeFarm()"
            @focus="comboFarms()"
            clearable
          />
          <v-autocomplete dense outlined  class="ma-1" style="height: 45px; width: auto;"
            id="building" 
            ref="building" 
            label="축사/건물/구역✽" 
            v-model="building"
            :items="buildingItems"
            :menu-props="{ top: false, offsetY: true }"
            no-data-text="자료(권한)이 없습니다."
            item-text="building_name"
            return-object
            @change="changeBuilding()"
            @focus="comboBuildings()"
            clearable
          />
          <v-autocomplete dense outlined  class="ma-1" style="height: 45px; "
            id="room" 
            ref="room" 
            label="방/위치✽" 
            v-model="room"
            :items="roomItems"
            :menu-props="{ top: false, offsetY: true }"
            no-data-text="자료(권한)이 없습니다."
            item-text="room_name"
            return-object
            @change="changeRoom()"
            @focus="comboRooms()"
            clearable
          />

          <v-textarea dense outlined auto-grow rows="1" hide-details class="ma-1"
            id="product"
            ref="product"
            :value="product && product.label"
            label="패키지 제품 선택✽"
            placeholder="클릭하여 패키지 제품을 선택하세요"
            append-icon="mdi-magnify"
            readonly
            clearable
            required
            @click="openProductDialog"
            @click:append="openProductDialog"
            @click:clear="clearProduct"
          ></v-textarea>

          <v-dialog v-model="productDialog" max-width="1150">
            <v-card>
              <v-card-title>패키지 제품 선택</v-card-title>
              <v-card-text style="padding-bottom: 0">
                <v-layout>
                  <v-text-field dense outlined class="mb-2 mr-2" style="height: 45px; flex: 1 1 0; min-width: 0"
                    id="dialog_maker_search"
                    ref="dialog_maker_search"
                    label="판매사명"
                    v-model="dialogMakerSearch"
                    placeholder="판매사명을 입력하세요"
                    append-icon="mdi-magnify"
                    clearable
                  />
                  <v-autocomplete dense outlined class="mb-2 mr-2" style="height: 45px; flex: 1 1 0; min-width: 0"
                    id="dialog_category_type"
                    ref="dialog_category_type"
                    label="장비유형"
                    v-model="dialogCategoryType"
                    :items="category_typeItems"
                    :menu-props="{ top: false, offsetY: true }"
                    item-text="name"
                    placeholder="장비유형을 선택하세요"
                    return-object
                    clearable
                    @change="changeDialogCategoryType"
                  />
                  <v-autocomplete dense outlined class="mb-2" style="height: 45px; flex: 1 1 0; min-width: 0"
                    id="dialog_device_type"
                    ref="dialog_device_type"
                    label="장비코드"
                    v-model="dialogDeviceType"
                    :items="dialogDeviceTypeItems"
                    :menu-props="{ top: false, offsetY: true }"
                    item-text="description"
                    placeholder="장비코드를 선택하세요"
                    return-object
                    clearable
                  />
                </v-layout>
                <v-data-table
                  dense
                  height="350px"
                  class="elevation-1 v-data-table product-dialog-table"
                  :headers="productDialogHeaders"
                  :items="filteredDialogProducts"
                  :items-per-page="50000"
                  no-data-text="선택 가능한 패키지 제품이 없습니다."
                  fixed-header
                  hide-default-footer
                  item-key="id"
                  :item-class="dialogItemRowBackground"
                  @click:row="highlightDialogProduct"
                ></v-data-table>
              </v-card-text>
              <v-card-actions style="padding: 16px 24px">
                <v-spacer></v-spacer>
                <v-btn rounded class="product-dialog-select-btn" :disabled="!dialogSelectedProduct.id" @click="confirmProductSelection">선택</v-btn>
                <v-btn rounded class="product-dialog-close-btn" @click="productDialog = false">닫기</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-layout>
            <v-text-field dense outlined class="ma-1" style="height: 45px; width: 180px"
              id="rut_number"
              ref="rut_number" 
              label="장비 일련번호" 
              v-model="rut_number"
              placeholder="장비 일련번호를 '정확히' 등록하세요"
              maxlength="30"
              clearable
            />

            <v-text-field dense outlined class="ma-1" style="height: 45px; width: 180px"
              id="fc_number" 
              ref="fc_number" 
              type="number"
              label="컨트롤러 번호" 
              v-model="fc_number"
              placeholder="연결된 fc 번호를 등록하세요"
              maxlength="20"
              clearable
            />
          </v-layout>


          <v-layout style="margin-top:-5px;">
            <v-text-field dense outlined class="ma-1" style="height: 45px; width: 180px"
              id="device_number" 
              ref="device_number" 
              label="축평원 장비 일련번호" 
              v-model="device_number"
              placeholder="축평원 장비 일련번호를 '정확히' 등록하세요"
              maxlength="30"
              clearable
            />

            <v-text-field dense outlined class="ma-1" style="height: 45px; width: 180px"
              id="sn_number"
              ref="sn_number"
              label="장비 고유번호✽"
              v-model="sn_number"
              placeholder="장비 고유번호를 '정확히' 등록하세요"
              maxlength="20"
              clearable
            />
          </v-layout>

          <v-text-field dense outlined class="ma-1" style="height: 45px; width: auto;"
            id="device_name"
            ref="device_name"
            label="장비 식별명✽"
            v-model="device_name"
            placeholder="사용자들이 알 수 있게 식별명을 입력하세요."
            maxlength="20"
            clearable
          />

          <v-layout>
            <v-text-field dense outlined class="ma-1" style="height: 45px; width: 180px"
              id="stall"
              ref="stall"
              label="칸 번호"
              v-model="stall"
              placeholder="칸 번호를 등록하세요"
              maxlength="20"
              clearable
            />
          </v-layout>

          <v-layout>
          <v-menu
            v-model="menuSensorSetdate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense outlined clearable class="ma-1" 
                id="setdate" 
                ref="setdate" 
                v-model="setdate"
                label="설치일✽"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title locale="ko-KR"
              v-model="setdate"
              @input="menuSensorSetdate = false"
            ></v-date-picker>
          </v-menu>
          <!-- <v-menu
            v-model="menuSensorDeldate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense outlined clearable class="shrink mr-1" style="width: 180px"
                id="deldate" 
                ref="deldate" 
                v-model="deldate"
                label="중지일"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title locale="ko-KR"
              v-model="deldate"
              @input="menuSensorDeldate = false"
            ></v-date-picker>
          </v-menu> -->
          </v-layout>

          <v-textarea outlined dense rows="2" name="input-7-4" style="height: auto; margin: -15px 3px 0px 5px"
            label="비고"
            id="history" 
            ref="history" 
            v-model="history"
            value=""
            persistent-hint :hint="hint"
          ></v-textarea>
          <v-card-actions class="d-block" >
            <v-row justify= "center" >
              <v-spacer ></v-spacer>
              <v-btn rounded class="normal-btn mr-2" style="height: 30px; width: 20px;  margin-bottom: 15px"
                :loading="loadingSave" 
                id="save" 
                ref="save"
                type="submit" 
                @click.prevent="save()">
                저장
              </v-btn>
              <v-btn rounded class="new-btn mr-2" style="height: 30px; width: 20px;  margin-bottom: 15px" 
                id="clear" 
                ref="clear" 
                @click="newRegister()">
                새로
              </v-btn>
              <v-spacer ></v-spacer>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>

      <v-card class="ma-0 ml-1 mt-0" width="65%">
        <v-layout wrap align-center>
          <v-radio-group v-model="filterStatus" row class="radio-group">
            <v-radio
              color="#004297"
              value="all"
              label="전체"
            ></v-radio>
            <v-radio
              color="#3a4f4f"
              value="active"
              label="가동"
            ></v-radio>
            <v-radio
              value="del"
              label="중지"
              color="#88191A"
            ></v-radio>
          </v-radio-group>
          <v-spacer></v-spacer>
          <a class="package-product-link mr-3 d-inline-flex align-center" href="#" @click.prevent="packageProductDialog = true">
            패키지 제품(모델) 정보 관리 <v-icon small color="#3a4f3f">mdi-open-in-new</v-icon>
          </a>
        </v-layout>
        <v-data-table dense nowrap height="550px" class="elevation-3  v-data-table" style=" margin-left: 1px; margin-right: 0px "
          id="items" 
          ref="items"
          :loading="loadingList" 
          :headers="headers"
          :items="displayItems"
          :items-per-page= "50000"
          no-data-text="등록된 자료가 없거나 접근 권한이 없습니다."
          fixed-header
          hide-default-footer
          @click:row="infoDetail"
          sort-by="room"
          group-by="room.farm.name"
          show-group-by
          item-key="id"
          :item-class="itemRowBackground"
          single-select
          :value="selectedRows"
          @input="selectedRows = $event"
          :search="search"
        >
          <template v-slot:group.header="{items, isOpen, toggle}">
            <th colspan="7">
              <v-icon @click="toggle"
                >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
              </v-icon>
              {{ items[0].room.farm.name }}
            </th>
          </template>
        </v-data-table>

        <v-card-title>
          <v-text-field dense style="width:200px" class="shrink mr-2"
            clearable
            v-model="farmSearch"
            append-icon="mdi-magnify"
            label="농장명"
            single-line
            hide-details
          ></v-text-field>
          <v-text-field dense style="width:250px" class="shrink"
            clearable
            v-model="search"
            append-icon="mdi-magnify"
            label="전체 검색"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-card-actions class="justify-center">
          <v-btn rounded-pill class="elevation-5 ma-3 rounded-pill normal-btn" style="height: 35px;"
            id="refreshList" 
            ref="refreshList" 
            @click="refreshList()">
            <v-icon left dark>mdi-refresh</v-icon>
            목록고침
          </v-btn>
        </v-card-actions>
      </v-card>

      <PackageProductDialog v-model="packageProductDialog" />
    </v-layout>
  </v-container>
</template>

<script>
import Apis from '@/api/apis'
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";
import PackageProductDialog from "./PackageProductDialog.vue";

export default {
  name: 'RegisterPackage',
  components: {
    PackageProductDialog,
  },
  data: () => ({
    packageProductDialog: false,
    device_id: "",
    save_device_id: "",
    selectedRows: [],
    search:'',
    farmSearch:'',

    items: [],
    headers: [
      { text: '농장/사업장', align: 'left', value: 'room.farm.name', sortable: false, groupable: false, width: "110px", class: 'green darken-4 white--text',divider: false  },
      { text: '방/구역', align: 'left', value: 'room.room.name', sortable: false, groupable: false, width: "100px", class: 'green darken-4 white--text',divider: false  },
      { text: '식별명', align: 'left', value: 'device_name', sortable: false, groupable: false, width: "130px", class: 'green darken-4 white--text',divider: false  },
      // { text: '장비유형', align: 'left', value: 'division.description', sortable: false, groupable: false, width: "140px", class: 'green darken-4 white--text',divider: false  },
      { text: '장비명', align: 'left', value: 'type.description', sortable: false, groupable: false, width: "150px", class: 'green darken-4 white--text',divider: false  },
      { text: '모델명', align: 'left', value: 'model', sortable: false, groupable: false, width: "130px", class: 'green darken-4 white--text',divider: false  },
      { text: '장비번호', align: 'left', value: 'local_sn', sortable: false, groupable: false, cellClass: 'nowrap-cell', class: 'green darken-4 white--text',divider: false  },
      { text: '칸 번호', align: 'left', value: 'stall', sortable: false, groupable: false, width: "80px", class: 'green darken-4 white--text',divider: false  },

      { text: '등록일', align: 'left', value: 'setdate', sortable: false, groupable: false, width: "130px", class: 'green darken-4 white--text',divider: false  },
      // { text: '중지일', align: 'left', value: 'sn', sortable: false, groupable: false, width: "100px", class: 'green darken-4 white--text',divider: false  },

    ],


    company : {},
    companyItems : [],
    farm : {},
    farmItems : [],
    building : {},
    buildingItems : [],
    room : {},
    roomItems : [],

    product: {},
    productItems: [],
    productDialog: false,
    dialogSelectedProduct: {},
    category_typeItems: Common.comboBaseCode("EX"),
    dialogCategoryType: {},
    dialogDeviceType: {},
    dialogDeviceTypeItems: [],
    dialogMakerSearch: '',
    productDialogHeaders: [
      { text: '판매사명', align: 'left', value: 'maker_name', sortable: false, groupable: false, width: "130px", class: 'green darken-4 white--text',divider: false  },
      { text: '제품ID', align: 'left', value: 'id', sortable: false, groupable: false, width: "90px", class: 'green darken-4 white--text',divider: false  },
      { text: '장비명', align: 'left', value: 'device_name', sortable: false, groupable: false, width: "140px", class: 'green darken-4 white--text',divider: false  },
      { text: '장비종류', align: 'left', value: 'device_type.description', sortable: false, groupable: false, width: "150px", class: 'green darken-4 white--text',divider: false  },
      { text: '제조사명', align: 'left', value: 'realmaker_name', sortable: false, groupable: false, width: "140px", class: 'green darken-4 white--text',divider: false  },
      { text: '모델', align: 'left', value: 'model', sortable: false, groupable: false, width: "120px", class: 'green darken-4 white--text',divider: false  },
      { text: '실모델명', align: 'left', value: 'realmodel', sortable: false, groupable: false, width: "140px", class: 'green darken-4 white--text',divider: false  },
      { text: '비고', align: 'left', value: 'memo', sortable: false, groupable: false, width: "160px", class: 'green darken-4 white--text',divider: false  },
    ],

    fc_number:"",
    rut_number:"",

    device_number:"",
    sn_number:"",
    stall:"",

    device_name: "",

    smart_mac: "",
    slave_id: "",
    setdate: "",
    // deldate: "",
    history: "",
    hint: "",

    loadingMac: false,
    loadingSave: false,
    loadingList: false,

    device_dialog : false,


    msgflag: true,

    menuSensorSetdate:false,
    // menuSensorDeldate:false,


    filterStatus: 'all',

  }),
  computed: {
    displayItems() {
      let result = this.items;
      if (this.filterStatus === 'active') {
        result = result.filter(item => !item.deldate || item.deldate === '');
      } else if (this.filterStatus === 'del') {
        result = result.filter(item => item.deldate && item.deldate !== '');
      }
      const farmKeyword = this.farmSearch.trim().toLowerCase();
      if (farmKeyword) {
        result = result.filter(item => (item.room?.farm?.name || '').toLowerCase().includes(farmKeyword));
      }
      return result;
    },
    filteredDialogProducts() {
      return this.productItems.filter((item) => {
        if (this.dialogCategoryType?.code && item.category_type?.code !== this.dialogCategoryType.code) {
          return false;
        }
        if (this.dialogDeviceType?.basecode && item.device_type?.code !== this.dialogDeviceType.basecode) {
          return false;
        }
        const makerKeyword = this.dialogMakerSearch.trim().toLowerCase();
        if (makerKeyword && !(item.maker_name || '').toLowerCase().includes(makerKeyword)) {
          return false;
        }
        return true;
      });
    }
  },
  created() {
    this.comboCompanies();
    this.comboFarms();
    this.comboBuildings();
    this.comboRooms();

    this.$store.commit("resMessage","");

    this.refreshList();
    sessionStorage.setItem("deviceTab",6)

  },

  methods: {
    newRegister() {
      this.clearData();
      this.save_device_id = "";
      this.selectedRows = [];

      this.$store.commit("resMessage","새로운 디바이스를 입력할 준비가 되었습니다.");
      this.$refs.farm.focus();
    },
    clearData() {
      this.device_id = "";

      this.company = {};

      this.rut_number = "";
      this.fc_number = "";
      this.device_number = ""
      this.sn_number = ""
      this.stall = ""
      this.product = {};

      this.device_name = "";

      this.farm = {};
      this.building = {};
      this.room = {};

      this.setdate = "";
      // this.deldate = "";
      this.history = "";
      this.hint = "";
    }, 
    checkData() {
      if (!this.farm.farm_cd) {
        this.$refs.farm.focus();
        return "농장/사업장을 선택하세요";
      }
      if (!this.building.building_cd) {
        this.$refs.building.focus();
        return "축사/건물/구역을 선택하세요";
      }
      if (!this.room.room_cd) {
        this.$refs.room.focus();
        return "방/위치를 선택하세요";
      }

      if (!this.product?.id) {
        this.$refs.product.focus();
        return "패키지 제품을 선택하세요";
      }

      if (!this.sn_number.trim()) {
        this.$refs.sn_number.focus();
        return "장비 고유번호를 정확히 입력하세요";
      }
      if (!this.device_name.trim()) {
        this.$refs.device_name.focus();
        return "장비 식별명을 입력하세요";
      }

      if (!this.setdate) {
        this.$refs.setdate.focus();
        return "설치일을 선택입력하세요";
      }
      return "";
    },
    save() {
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        return;
      }

      this.loadingSave = true;

      this.save_device_id = this.device_id;

      if (this.device_id) {
        //업데이트
        Apis.updatePackageDevice({
          "id" : this.device_id,
          "farm" : this.farm.farm_cd,
          "room" : this.room.room_cd,
          "division" : this.product?.category_type ? this.product.category_type.code : null,
          "type" : this.product?.device_type ? this.product.device_type.code : null,
          "model" : this.product?.model || "",
          "sn" : this.device_number || null,
          "local_sn" : this.sn_number,
          "stall" : this.stall,
          "product" : this.product?.id || null,
          "device_name" : this.device_name,
          "history" : this.history.trim(),
          "rsvr1" : this.rut_number || null,
          "rsvr2" : "",
          "no1" : Number(this.fc_number) || null, //팬컨트롤러 번호
          "no2" : null,
          // "etc3" : this.history.trim(),
          "setdate" : this.setdate,
          },(res) => {
            if (res.result) {
              this.$store.commit("resMessage",res.message);
              this.loadingSave = false;
              this.msgFlag = false;
              
              this.save_device_id = this.device_id;
              this.clearData();

              this.refreshList();
            } else {
              this.loadingSave = false;
              alert(res.message);

                // 디버깅용
              console.log("저장할 데이터:", {
                "id" : this.device_id,
                "farm" : this.farm.farm_cd,
                "room" : this.room.room_cd,
                "division" : this.product?.category_type ? this.product.category_type.code : null,
                "type" : this.product?.device_type ? this.product.device_type.code : null,
                "model" : this.product?.model || "",
                "sn" : this.device_number || null,
                "local_sn" : this.sn_number,
                "stall" : this.stall,
                "product" : this.product?.id || null,
                "device_name" : this.device_name,
                "history" : this.history.trim(),
                "rsvr1" : this.rut_number || null,
                "rsvr2" : "",
                "no1" : Number(this.fc_number) || null, //팬컨트롤러 번호
                "no2" : null,
                // "etc3" : this.history.trim(),
                "setdate" : this.setdate,
              });

            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("API 호출 오류",err)
              alert(err);
          }
        )
      } else {
        //등록
        Apis.insertPackageDevice({
          "farm" : this.farm.farm_cd,
          "room" : this.room.room_cd,
          "division" : this.product?.category_type ? this.product.category_type.code : null,
          "type" : this.product?.device_type ? this.product.device_type.code : null,
          "model" : this.product?.model || "",
          "sn" : this.device_number || null,
          "local_sn" : this.sn_number,
          "stall" : this.stall,
          "product" : this.product?.id || null,
          "device_name" : this.device_name,
          "history" : this.history.trim(),
          "rsvr1" : this.rut_number || null,
          "rsvr2" : "",
          "no1" : Number(this.fc_number) || null, //팬컨트롤러 번호
          "no2" : null,
          // "etc3" : this.history.trim(),
          "setdate" : this.setdate,
          },(res) => {
            if (res.result) {
              this.$store.commit("resMessage",res.message);
              this.msgFlag = false;
              this.loadingSave = false;
              this.msgFlag = false;
              // console.log("저장");
              this.refreshList();
              this.save_device_id = this.device_id;
              this.clearData();
            } else {
              this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("API 호출 오류",err)
              alert(err);
          }
        )
      }
    },
    async infoDetail(value,row) {
      row.select(true)
      this.$store.commit("resMessage","");

      this.clearData();

      Apis.infoPackageDevice({
        id: value.id,
        },async (res) => {  
          if (res.result) {
            // console.log(res.data)
 
            this.device_id = res.data.id;
            this.save_device_id = res.data.id;
            this.company = {company_cd: res.data.room.company.code, company_name: res.data.room.company.name};
            this.farm = {farm_cd: res.data.room.farm.code, farm_name: res.data.room.farm.name};
            this.building = {building_cd: res.data.room.building.code, building_name: res.data.room.building.name};
            this.room = {room_cd: res.data.room.room.code, room_name: res.data.room.room.name};

            this.rut_number = res.data.rsvr1;
            this.fc_number = res.data.no1;

            this.device_number = res.data.sn;
            this.sn_number = res.data.local_sn;
            this.stall = res.data.stall;
            this.product = {};
            if (res.data.product) {
              const productId = res.data.product.id || res.data.product;
              this.comboProducts(productId);
            }
            this.device_name = res.data.device_name;
            this.setdate = res.data.setdate;
            this.history = res.data.history; 
            this.hint = res.data.chguser + "님이 " + res.data.chgdate + "에 최종 수정";

          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류",err)
            // alert(err);
        }
      ); 
 
 

      // 인포
    },
    refreshList() {
      if (this.msgFlag) this.$store.commit("resMessage","");
      this.loadingList = true;
      // // console.log("리스트");
  
      //조회
      Apis.listPackageDevices({
        } ,(res) => {  // 정상처리
        // console.log("res",res);
        this.items = res.data;

        if (this.msgFlag) this.$store.commit("resMessage",res.message);

        this.loadingList = false;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("listFarms 호출 오류",err);
        this.$router.push("/");
      }) 
    }, 
   comboCompanies() {
      Apis.comboCompanies({
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.companyItems = res.data;
          } else {
            this.companyItems = [];
            alert(res.message);  
          } 
        }).catch( (err) => {  // API 오류 처리
            console.log("comboCompanies API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    changeCompany() {   // 하위 콤보 지우기;
      this.farm = {};
      this.building = {};
      this.room = {};
    },
    comboFarms() {
      Apis.comboFarms({
        // company_cd: this.company && this.company.company_cd || "",
        company_cd: "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
        if (res.result) {
            this.farmItems = res.data;
          } else {
            this.farmItems = [];
            alert(res.message);  
          } 
          }).catch( (err) => {  // API 오류 처리
          console.log("comboFarms API 호출 오류",err)
          alert(err);
        }
      ) 
    },
    changeFarm() {      // 하위콤보 선택시 상위 콤보 동시 세팅, 하위콤보 지우기
      // if (this.farm && this.farm.company_cd) {
        // this.company = {company_cd: this.farm.company_cd, company_name: this.farm.company_name};
        this.building = {};
        this.room = {};
      // }
    },
    comboBuildings() {
      Apis.comboBuildings({
        company_cd:this.company &&  this.company.company_cd || "",
        farm_cd: this.farm && this.farm.farm_cd || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
        if (res.result) {
            this.buildingItems = res.data;
          } else {
            this.buildingItems = [];
            alert(res.message);  
          } 
        }).catch( (err) => {  // API 오류 처리
            console.log("comboBuildings API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    changeBuilding() {      // 하위콤보 선택시 상위 콤보 동시 세팅
      if (this.building && this.building.company_cd) {
        this.company = {company_cd: this.building.company_cd, company_name: this.building.company_name};
      }
      if (this.building && this.building.farm_cd) {
        this.farm = {farm_cd: this.building.farm_cd, farm_name: this.building.farm_name};
      }
        this.room = {};
    },
    comboRooms() {
      Apis.comboRooms({
        company_cd:this.company &&  this.company.company_cd || "",
        farm_cd: this.farm && this.farm.farm_cd || "",
        building_cd: this.building && this.building.building_cd || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        name_flag: true, 
        },(res) => {  
          if (res.result) {
            this.roomItems = res.data;
          } else {
            this.roomItems = [];
            alert(res.message);  
          } 
        }).catch( (err) => {  // API 오류 처리
            console.log("comboRooms API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    changeRoom() {      // 하위콤보 선택시 상위 콤보 동시 세팅
      if (this.room && this.room.company_cd) {
        this.company = {company_cd: this.room.company_cd, company_name: this.room.company_name};
      }
      if (this.room && this.room.farm_cd) {
        this.farm = {farm_cd: this.room.farm_cd, farm_name: this.room.farm_name};
      }
      if (this.room && this.room.building_cd) {
        this.building = {building_cd: this.room.building_cd, building_name: this.room.building_name};
        // this.device_name = this.room.building_name + " " + this.room.room_name;
      } else{
        this.device_name = "";
      }
    },
    comboProducts(selectedId){
      Apis.listPackageProducts({
      },(res) => {
        if (res.result) {
          const buildLabel = (item) => [
              item.maker_name,
              item.device_name,
              item.model,
              item.device_type ? item.device_type.description : "",
            ].filter(Boolean).join(" - ");

          this.productItems = res.data
            .filter((item) => !item.deldate)
            .map((item) => ({ ...item, label: buildLabel(item) }));

          if (selectedId) {
            let found = this.productItems.find((item) => item.id === selectedId);
            if (!found) {
              // 이미 미사용 처리된 제품이라도 기존에 저장된 값은 그대로 보여줘야 함
              const original = res.data.find((item) => item.id === selectedId);
              if (original) {
                found = { ...original, label: buildLabel(original) };
                this.productItems.push(found);
              }
            }
            if (found) this.product = found;
          }
        } else {
          this.productItems = [];
          alert(res.message);
        }
      }).catch( (err) => {  // API 오류 처리
          console.log("listPackageProducts API 호출 오류",err)
          alert(err);
      })
    },
    openProductDialog() {
      this.comboProducts();
      this.dialogMakerSearch = '';
      this.dialogSelectedProduct = this.product?.id ? this.product : {};
      this.dialogCategoryType = this.product?.category_type
        ? { code: this.product.category_type.code, name: this.product.category_type.description }
        : {};
      this.dialogDeviceType = this.product?.device_type
        ? { basecode: this.product.device_type.code, description: this.product.device_type.description }
        : {};
      if (this.dialogCategoryType.code) {
        Apis.baseCodeList({
          division: this.dialogCategoryType.code.slice(-2),
        }, (res) => {
          this.dialogDeviceTypeItems = res.result ? res.data : [];
        }).catch((err) => {
          console.log("baseCodeList API 호출 오류", err);
          alert(err);
        });
      } else {
        this.dialogDeviceTypeItems = [];
      }
      this.productDialog = true;
    },
    changeDialogCategoryType() {
      this.dialogCategoryType = this.dialogCategoryType || {};
      this.dialogDeviceType = {};
      if (!this.dialogCategoryType.code) {
        this.dialogDeviceTypeItems = [];
        return;
      }
      Apis.baseCodeList({
        division: this.dialogCategoryType.code.slice(-2),
      }, (res) => {
        this.dialogDeviceTypeItems = res.result ? res.data : [];
      }).catch((err) => {
        console.log("baseCodeList API 호출 오류", err);
        alert(err);
      });
    },
    highlightDialogProduct(item) {
      this.dialogSelectedProduct = item;
    },
    dialogItemRowBackground(item) {
      return item.id === this.dialogSelectedProduct.id ? 'selected' : '';
    },
    confirmProductSelection() {
      if (!this.dialogSelectedProduct.id) return;
      this.product = this.dialogSelectedProduct;
      this.productDialog = false;
    },
    clearProduct() {
      this.product = {};
    },
    itemRowBackground(item) {
      // console.log("key",item.controller_key,save_controller_id);
      return item.id == this.save_device_id ? 'selected' : '' ;

    },



  }  // -----------methods 

}
// 01-06
</script>

<style lang="scss" scoped>
.v-data-table::v-deep{
  thead.v-data-table-header tr {
    th {
      background-color: #436251 !important;
      color: white !important;
      font-size:13px;
      height:40px !important;
    }
  }
  .nowrap-cell {
    white-space: nowrap;
  }
}
.package-product-link {
  color: #3a4f3f;
  font-weight: bold;
  text-decoration: underline;
  font-size: 13px;
}
.product-dialog-select-btn{
  background-color: #3a4f3f !important;
  color: #fff;
  width: 100px;
  height: 40px !important;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: -0.5px;
  border-color: transparent;
  margin-right: 4px;
}
.product-dialog-select-btn.v-btn--disabled{
  background-color: #c0c0c0 !important;
  color: #fff !important;
}
.product-dialog-close-btn{
  background-color: #909090 !important;
  color: #fff;
  width: 100px;
  height: 40px !important;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: -0.5px;
  border-color: transparent;
}
.product-dialog-table::v-deep{
  table {
    table-layout: fixed;
  }
  td {
    white-space: normal;
    word-break: break-word;
  }
  thead.v-data-table-header tr th {
    border: none !important;
    box-shadow: none !important;
  }
}
::v-deep .radio-group{
  padding:0 5px !important;
  height:35px !important;
  margin-top:5px;
}
.flex{
  display: flex;
}
.s-bt{
  justify-content: space-between;
}
.normal-btn , .search-btn{
  background-color: #3a4f3f !important;
  color:white;
  width:100px;
  height:45px !important;
  font-weight:bold;
  font-size:15px;
  letter-spacing: -0.5px;
  border-color:transparent;
}
.search-btn{
  height:40px !important;
  width:50px !important;
  border-radius:20px !important;
}
.new-btn{
  color:#3a4f3f !important;
  width:100px;
  height:45px !important;
  font-weight:bold;
  font-size:15px;
  letter-spacing: -0.5px;
  border-color:transparent;
  background-color: rgb(248, 248, 248) !important;
}
.dialog-btn{
  color:white !important;
  width:100px;
  height:45px !important;
  font-weight:bold;
  font-size:15px;
  letter-spacing: -0.5px;
  border-color:transparent;
  background-color: #88191a !important;
}
</style>
